/**
 *
 * Asynchronously loads the component for PrivacyPolicy
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import("./index"));
